<template>
    <div>
        <div class="form-element-wrapper">
            <div class="form-element">
                <div class="label"><nobr>Amplitudenausschlag</nobr></div>
                <Slider id="barHeight"
                        name="barHeight"
                        :value="wave.barHeight"
                        @update="setWaveValue(idx, 'barHeight', $event)"
                        min="0.1"
                        max="0.9"
                        step="0.1"
                    ></Slider>
            </div>
            <!-- <template v-if="wave.style == 'bar' || wave.style == 'modern'">
                <div class="my-3 form-element">
                    <div class="label">Balkenbreite</div>
                    <Slider name="barWidth"
                            :value="wave.barWidth"
                            @update="setWaveValue(idx, 'barWidth', $event)"
                            min="1" max="20">

                    </Slider>
                </div>
                <div class="my-3 form-element">
                    <div class="label">Balkenabstand</div>
                    <Slider
                           name="barGap"
                           :value="wave.barGap"
                           @update="setWaveValue(idx, 'barGap', $event)"
                           min="0" max="40">

                    </Slider>
                </div>
                <div class="my-3 form-element" v-if="wave.style == 'bar'">
                    <div class="label">Balkenhöhe bei Stille</div>
                    <Slider
                           name="barMinHeight"
                           :value="wave.barMinHeight"
                           @update="setWaveValue(idx, 'barMinHeight', $event)"
                           min="1" max="20" step="1">
                    </Slider>
                </div>
            </template>
            <div class="my-3 form-element">
                <div class="label">Transparenz</div>
                <Slider
                       name="transparency"
                       :value="wave.transparency"
                       @update="setWaveValue(idx, 'transparency', $event)"
                       step="5" min="0" max="75"></Slider>
            </div> -->
        </div>
    </div>
</template>

<script type="text/javascript">
import { mapFields } from 'vuex-map-fields';
import Slider from "~/scripts/Components/Slider.vue";
import Pipeline from "~/scripts/Pipeline/Pipeline.js";
import RangeSlider from "~/scripts/Components/RangeSlider.vue";

export default {
    props: {
        wave: Object,
        idx: Number
    },

    components: {
        RangeSlider,
        Slider
    },

    computed: {
        ...mapFields({
            border: 'stageConfiguration.border',
            borderColor: 'stageConfiguration.borderColor',
            backgroundType: 'stageConfiguration.background.type'
        })
    },

    methods: {
        setWaveValueFromEvent(idx, $event) {
            if($event && $event.target) {
                var value = $event.target.value;
                var option = $event.target.name.split('__')[0];

                this.setWaveValue(idx, option, value);
            }
        },

        setWaveValue(idx, option, value) {
            let wave = this.$store.state.wavesurferWaves[idx];

            Pipeline.setWaveValue(idx, option, value);
            Pipeline.updateWaveFromUserConfig(wave, option, value);

            if (option == 'barHeight' && this.backgroundType == 'image') {
                Pipeline.setWaveformBackgroundGradient();
            }
        }
    },
}
</script>
